import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const ease = [0.22, 1, 0.36, 1] as const;
type DropdownPanelProps = {
  open: boolean;
  className?: string;
  children: React.ReactNode;
};

// Shared square popover surface used by every dropdown in the request bar
export function DropdownPanel({
  open,
  className = 'left-0 right-0 min-w-[300px]',
  children
}: DropdownPanelProps) {
  return <AnimatePresence data-id="element-408" data-mp="1chbh7wy7rmet">
      {open && <motion.div initial={{
      opacity: 0,
      y: -4
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -4
    }} transition={{
      duration: 0.22,
      ease
    }} className={`absolute top-full z-30 mt-2 border border-line bg-paper text-ink shadow-[0_16px_40px_-16px_rgba(0,0,0,0.22)] ${className}`} data-id="element-409" data-mp="1giwwtq24uesp">
          {children}
        </motion.div>}
    </AnimatePresence>;
}
type DropdownOptionProps = {
  label: string;
  selected: boolean;
  multi?: boolean;
  icon?: React.ReactNode;
  iconWidth?: string; // wider slot for paired icons
  dense?: boolean;
  divided?: boolean; // hairline above, to set apart closing options
  onSelect: () => void;
};
export function DropdownOption({
  label,
  selected,
  multi,
  icon,
  iconWidth = 'w-5',
  dense,
  divided,
  onSelect
}: DropdownOptionProps) {
  return <li role="option" aria-selected={selected} className={divided ? 'mt-1 border-t border-line pt-1' : undefined} data-id="element-410" data-mp="1wc30ej7yzr9d">
      <button type="button" onClick={onSelect} className={`flex w-full items-center gap-3 px-5 text-left text-[15px] transition-colors duration-200 hover:bg-bone ${dense ? 'py-2.5' : 'py-3'} ${selected ? 'font-medium' : 'font-light'}`} data-id="element-411" data-mp="2t2vcl5rs8z5v">
        {multi && <span className={`flex h-4 w-4 shrink-0 items-center justify-center border border-ink transition-colors duration-200 ${selected ? 'bg-ink text-paper' : 'bg-paper'}`} aria-hidden="true" data-id="element-412" data-mp="2f7ji8zhjhaph">
            {selected && <CheckIcon className="h-3 w-3" strokeWidth={2} data-id="element-413" data-mp="153rx5tdtjn9j" />}
          </span>}
        {icon && <span className={`flex ${iconWidth} shrink-0 items-center justify-center ${selected ? 'text-ink' : 'text-ink/60'}`} aria-hidden="true" data-id="element-414" data-mp="1a45v2ilphgtu">
            {icon}
          </span>}
        <span className="flex-1" data-id="element-415" data-mp="10agp5ox9t0g1">{label}</span>
        {!multi && selected && <CheckIcon className="h-4 w-4 shrink-0" strokeWidth={1.5} aria-hidden="true" data-id="element-416" data-mp="mbgxs9idi7g6" />}
      </button>
    </li>;
}